import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Suporte.module.css";
import Alerta from "../../components/alerta/Alerta";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import { Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdDelete, MdSearch, MdClose } from "react-icons/md";
import SuporteApi from "../../services/SuporteApi";
import Paginacao from "../../components/paginacao/Paginacao";
import { IoEyeSharp } from "react-icons/io5";
import Loader from "../../components/loader/Loader";
import { FaReplyAll } from "react-icons/fa";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Suporte() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Modais para responder e ver
    const [mostrarModalResponder, setMostrarModalResponder] = useState(false);
    const [mostrarModalVer, setMostrarModalVer] = useState(false);
    const [suporteSelecionado, setSuporteSelecionado] = useState(null);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);

    //Para rodar a tabela, paginação e filtro
    const [suportes, setSuportes] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState();
    const [ticket, setTicket] = useState("");
    const [tipo, setTipo] = useState(0);
    const [respondido, setRespondido] = useState(2);
    const [ticketFiltro, setTicketFiltro] = useState("");
    const [tipoFiltro, setTipoFiltro] = useState(0);
    const [respondidoFiltro, setRespondidoFiltro] = useState(2);
    const [paginaAtual, setPaginaAtual] = useState(1);

    //Para armazenar o enum tipos de suporte com Id, nome e descrição
    const [tiposSuporte, setTiposSuporte] = useState([]);

    const [respostaAdicionar, setRespostaAdicionar] = useState("");

    const [resposta, setResposta] = useState([
        { key: 0, value: "Pendente" },
        { key: 1, value: "Respondido" }
    ]);

    //Função para filtro de busca
    async function BuscarSuportes() {
        setTicket(ticketFiltro);
        setTipo(tipoFiltro);
        setRespondido(respondidoFiltro);
        setPaginaAtual(1);
        await CarregarSuportes();
    }

    //Função para resetar  filtro de busca
    async function ResetarSuportes() {
        setTicket("");
        setTipo(0);
        setRespondido(2);
        setTicketFiltro("");
        setTipoFiltro(0);
        setRespondidoFiltro(2);
        setPaginaAtual(1);
        await CarregarSuportes();
    }

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
        await CarregarSuportes();
    }

    //Função para abrir o modal de ver
    const AbrirModalVer = (suporte) => {
        setLoading(true);
        setSuporteSelecionado(suporte);
        setMostrarModalVer(true);
        setLoading(false);
    };

    //Função para abrir o modal de responder
    const AbrirModalResponder = (suporte) => {
        setLoading(true);
        setSuporteSelecionado(suporte);
        setMostrarModalResponder(true);
        setLoading(false);
    };

    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalVer(false);
        setMostrarModalResponder(false);
        setSuporteSelecionado(null);
        setRespostaAdicionar("");
    };

    const ResponderSuporte = async () => {

        try {
            setLoading(true);
            await SuporteApi.responderSuporteAsync(suporteSelecionado.suporteID, respostaAdicionar);
            CarregarSuportes();
            setMensagemAlerta(`Suporte respondido com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao responder suporte: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    }

    //Função para listar os suportes
    async function CarregarSuportes() {
        try {
            const listaSuportes = await SuporteApi.listarSuportesComPaginacaoAsync(
                paginaAtual,
                tipo,
                respondido,
                ticket
            );
            setQuantidadeItens(listaSuportes.quantidadeRegistros);
            setSuportes(listaSuportes.registros);
        } catch (error) {
            console.error("Erro ao carregar suportes:", error.response.data);
        }
    }

    //Função para obter todos os tipos de suporte
    async function BuscarTiposSuporte() {
        try {
            const tipos = await SuporteApi.listarTiposSuporteAsync();
            setTiposSuporte(tipos);
        } catch (error) {
            console.error("Erro ao buscar tipos de suporte:", error.response.data);
        }
    }

    const totalPaginas = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    useEffect(() => {
        CarregarSuportes();
        BuscarTiposSuporte();
    }, []);

    useEffect(() => {
        CarregarSuportes();
    }, [paginaAtual, tipo, respondido, ticket]);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Suportes</h4>
                    </div>

                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>
                        <InputBuscar
                            type="text"
                            id="hidenTicket"
                            placeholder="Ticket"
                            name="ticket"
                            maxLength={15}
                            value={ticketFiltro}
                            onChange={(e) => setTicketFiltro(e.target.value)}
                        />

                        <Form.Select
                            id="hidenTipo"
                            name="Tipo"
                            value={tipoFiltro}
                            onChange={(e) => setTipoFiltro(e.target.value)}
                        >
                            <option value="">Tipo de suporte</option>
                            {tiposSuporte.map((tipo) => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.descricao}
                                </option>
                            ))}
                        </Form.Select>

                        <Form.Select
                            id="hidenResposta"
                            name="Resposta"
                            value={respondidoFiltro}
                            onChange={(e) => setRespondidoFiltro(e.target.value)}
                        >
                            <option value="2">Resposta</option>
                            {resposta.map((item) => (
                                <option key={item.key} value={item.key}>
                                    {item.value}
                                </option>
                            ))}
                        </Form.Select>
                        <div className={style.container_filtro2}>

                            <Button onClick={BuscarSuportes} id={style.botao_buscar}>
                                <MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarSuportes} id={style.botao_resetar}>
                                <MdClose /> Limpar
                            </Button>
                        </div>


                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Ticket</th>
                                        <th>Descrição</th>
                                        <th>Tipo</th>
                                        <th>Data de envio</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {suportes.map((suporte) => (
                                        <tr className={style.tabela_corpo} key={suporte.suporteID}>
                                            <td title={suporte.ticket}>
                                                <span className={`badge ${suporte.respondido ? "bg-success" : "bg-danger"}`}
                                                    style={{ fontSize: "14px", padding: "6px 12px" }}
                                                >
                                                    {suporte.ticket}
                                                </span>
                                            </td>
                                            <td title={suporte.descricao}>{suporte.descricao}</td>
                                            <td
                                                title={
                                                    tiposSuporte.find((t) => t.id === suporte.tipoSuporte)?.descricao
                                                }
                                            >
                                                {tiposSuporte.find((t) => t.id === suporte.tipoSuporte)?.descricao}
                                            </td>
                                            <td title={new Date(suporte.dataEnvio).toLocaleString("pt-BR")}>{new Date(suporte.dataEnvio).toLocaleString("pt-BR")}</td>

                                            <td className={style.coluna_acoes}>
                                                {!suporte.respondido &&
                                                    (<Link onClick={() => AbrirModalResponder(suporte)} className={style.botao_responder}>
                                                        <FaReplyAll
                                                            title="Responder" />
                                                    </Link>)
                                                }
                                                <Link onClick={() => AbrirModalVer(suporte)} className={style.botao_visualizar}>
                                                    <IoEyeSharp
                                                        title="Vizualizar" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Controle de Paginação */}
                        <Paginacao
                            id={style.configuracao_paginacao}
                            paginaAtual={paginaAtual}
                            totalPages={totalPaginas}
                            onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                        />
                    </div>
                    {/* Modal para responder suporte */}
                    <Modal show={mostrarModalResponder} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Responder suporte de ticket: {suporteSelecionado?.ticket}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form.Group controlId="formResposta" className="mb-3">
                                <Form.Label>Resposta</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    row={3}
                                    placeholder="Digite a resposta"
                                    name="resposta"
                                    value={respostaAdicionar}
                                    onChange={(e) => setRespostaAdicionar(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={FecharModal} disabled={loading}>
                                Cancelar
                            </Button>
                            <Button variant="success" onClick={ResponderSuporte} disabled={loading}>
                                Enviar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {/* Modal para vizualizar suporte */}
                    <Modal show={mostrarModalVer} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Visualizar Suporte</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            <Form.Label>Requisição feita por</Form.Label>

                            <Form.Group className="mb-3">
                                <Form.Control
                                    type="text"
                                    value={suporteSelecionado?.nomePessoa}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control
                                    type="text"
                                    value={suporteSelecionado?.emailPessoa}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Ticket</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={suporteSelecionado?.ticket || ""}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Tipo</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={
                                        tiposSuporte?.length > 0 && suporteSelecionado?.tipoSuporte
                                            ? tiposSuporte.find((t) => t.id === suporteSelecionado.tipoSuporte)?.descricao || "Tipo não encontrado"
                                            : "Carregando..."
                                    }
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Descrição</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={suporteSelecionado?.descricao || ""}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Data de Envio</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={new Date(suporteSelecionado?.dataEnvio).toLocaleString("pt-BR")}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Resposta</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={suporteSelecionado?.resposta || "Pendente"}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Data de Resposta</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={suporteSelecionado?.dataResposta
                                        ? new Date(suporteSelecionado.dataResposta).toLocaleString("pt-BR")
                                        : "Pendente"}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>
                        </Modal.Body>
                    </Modal>
                </div>
            </Topbar>
        </Sidebar>
    );
}

export default Suporte;
